// The steps every app animates on; motion.css states the same values for CSS
export const MOTION = {
  // hover and press feedback
  instant: 120,
  short: 200,
  medium: 300,
  mediumLong: 400,
  long: 500,
  // timeline range tweens (timeline-helpers, explore, authors, essays)
  tween: 1000,
  // how long the pointer rests before a tooltip or popup shows
  hoverDelay: 800,
} as const

// `cubic-bezier(0.25, 0.1, 0.25, 1)` is this same curve written out
export const MOTION_EASE = 'ease'

// A JS duration as a CSS time, to hand it to CSS through a custom property
export const ms = (value: number) => `${value}ms`
